var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgConnections(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.197 8C3.332 8 0 9.07 0 11.2V14h10.393v-2.8c0-2.13-3.332-3.2-5.196-3.2zm0-1.6c1.538 0 2.789-1.435 2.789-3.2 0-1.765-1.251-3.2-2.79-3.2C3.66 0 2.409 1.435 2.409 3.2c0 1.765 1.25 3.2 2.789 3.2zm5.054 1.655c.924.768 1.562 1.792 1.562 3.145V14H15v-2.8c0-1.847-2.789-2.898-4.75-3.145zM9.629 6.4c1.538 0 2.789-1.435 2.789-3.2 0-1.765-1.251-3.2-2.789-3.2C9.2 0 8.8.119 8.434.32A5.49 5.49 0 019.23 3.2a5.49 5.49 0 01-.797 2.88c.366.201.765.32 1.195.32z",
    fill: "#666"
  })));
}

export default SvgConnections;